<div id="togglePerPage" style="font-size: 15px;" *ngIf="perPageOptions.length > 0"> Results per page :
    <span class="nx-margin-3xs" (click)="onPerPageClick.emit(option)" *ngFor="let option of perPageOptions">
        <nx-link [ngClass]="(perPage==option.value) ? 'apply-underline' : 'remove-underline'" [ngStyle]="{'color': (perPage==option.value) ? '#000000' : '#006192'}">
            <a>{{option.label}}</a>
        </nx-link>
    </span>
</div>